import { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { getChatHistory, toggleBotInterface } from '../../../../../data/store/botSlice';
import * as _ from 'lodash'
import dayjs from 'dayjs'
import useChatbotActions from '../../../../../data/hooks/useChatBotActions';
import ChatHistoryTile from '../../../../components/ChatHistoryTile';
import OriAvatar from "../../../../components/Custom/OriAvatar";
import useLanguage from '../../../../../data/hooks/useLanguage';

const ChatWelcomePage = () => {
    const dispatch = useDispatch()
    const avatarUrl = useSelector((state) => state.themeDetails.avatarUrl)
    const botName = useSelector((state) => state.themeDetails.botName)
    const homeHeading = useSelector((state) => state.themeDetails.homeHeading)
    const conversationContinueButtonText = useLanguage("botUiTemplate.conversationContinueButton")
    const conversationStartButtonText = useLanguage("botUiTemplate.conversationStartButton")
    const tenantId = useSelector((state) => state.botDetails.tenantId)
    const psid = useSelector((state) => state.botDetails.psid)
    const lastChatData = useSelector((state) => _.get(state, 'botDetails.recentChat', null))
    const autoStartChat = useSelector((state) => state.botDetails.autoStartChat)
    const { handleStartNewConversation, isChatActive, handleChatClicked } = useChatbotActions()

    const isLastChatActive = useMemo(() => {
        return isChatActive(lastChatData)
    }, [lastChatData, isChatActive])

    // Auto-start conversation when autoStartChat is enabled
    useEffect(() => {
        console.log('ChatWelcomePage - autoStartChat:', autoStartChat)
        if (autoStartChat) {
            console.log('ChatWelcomePage - Auto-starting conversation')
            if (isLastChatActive && lastChatData) {
                console.log('ChatWelcomePage - Clicking last chat')
                handleChatClicked(lastChatData)
            } else {
                console.log('ChatWelcomePage - Starting new conversation')
                handleStartNewConversation()
            }
        }
    }, [autoStartChat])

    useEffect(() => {
        // Fetching the last chat message to show on the welcome page
        dispatch(getChatHistory({
            tenantId,
            psid,
            page: 1,
            limit: 1,
            timezone: "Asia/Calcutta",
            "filters": {
                "startDate": dayjs().subtract(3, 'months').toISOString(),
                "endDate": dayjs().toISOString()
            },
        }))
    }, [dispatch, tenantId, psid])

    return (
        <div className='flex flex-col justify-center gap-6 items-center p-4 h-full relative'>
            <button
                onClick={() => { dispatch(toggleBotInterface()) }}
                className="absolute rounded-full text-2xl w-10 h-10 top-2 right-2 text-primaryContrast hover:text-primary hover:bg-primaryContrast transition"
            >
                <i className='ri-fullscreen-exit-line' />
            </button>
            <div className='h-36 aspect-square rounded-full FadeIn'>
                <OriAvatar alt={botName} url={avatarUrl} />
            </div>
            <p className='text-2xl text-primaryContrast font-black text-center FadeIn'>
                {homeHeading ? homeHeading : botName}
            </p>
            <div className='w-full flex flex-col gap-2 FadeIn'>

                <div
                    onClick={isLastChatActive ? () => handleChatClicked(lastChatData) : handleStartNewConversation}
                    className='p-3 px-5 cursor-pointer flex justify-between bg-primary text-lg text-primaryContrast rounded-3xl w-full hover:bg-secondary hover:text-secondaryContrast transition-all duration-500'>
                    <p className='font-bold'>
                        {isLastChatActive ? (
                            conversationContinueButtonText
                        ) : (
                            conversationStartButtonText
                        )}
                    </p>
                    <p>
                        <i class="ri-send-plane-2-line"></i>
                    </p>
                </div>
                {lastChatData && (
                    <ChatHistoryTile chat={lastChatData} />
                )}
            </div>
        </div>
    )
}

export default ChatWelcomePage